// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// HTTP Content Type constants.
export enum HttpContentType {
    Json = 'application/json',
    JsonApi = 'application/vnd.api+json',
    OctetStream = 'application/octet-stream',
    Text = 'application/text',
    Zip = 'application/zip',
}
